"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 36 36" },
  React.createElement("path", { d: "M2 3v30a1 1 0 0 0 1 1h16.092V21.607h-4.169v-4.828h4.171v-3.556c0-3.45 2.011-6.05 5.209-6.37a34.44 34.44 0 0 1 4.736.176v4.32h-2.566c-1.016 0-2.385.424-2.385 1.53 0 .888-.008 3.831-.008 3.9h4.782l-.622 4.83h-4.16V34H33a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1z" })
);

